/*!
 * Fuse.js v3.6.1 - Lightweight fuzzy-search (http://fusejs.io)
 * 
 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Fuse", [], t) : "object" == typeof exports ? exports.Fuse = t() : e.Fuse = t();
}(this, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var i = r(1),
        a = r(7),
        s = a.get,
        c = (a.deepValue, a.isArray),
        h = function () {
      function e(t, r) {
        var n = r.location,
            o = void 0 === n ? 0 : n,
            i = r.distance,
            a = void 0 === i ? 100 : i,
            c = r.threshold,
            h = void 0 === c ? .6 : c,
            l = r.maxPatternLength,
            u = void 0 === l ? 32 : l,
            f = r.caseSensitive,
            v = void 0 !== f && f,
            p = r.tokenSeparator,
            d = void 0 === p ? / +/g : p,
            g = r.findAllMatches,
            y = void 0 !== g && g,
            m = r.minMatchCharLength,
            k = void 0 === m ? 1 : m,
            b = r.id,
            S = void 0 === b ? null : b,
            x = r.keys,
            M = void 0 === x ? [] : x,
            _ = r.shouldSort,
            w = void 0 === _ || _,
            L = r.getFn,
            A = void 0 === L ? s : L,
            O = r.sortFn,
            C = void 0 === O ? function (e, t) {
          return e.score - t.score;
        } : O,
            j = r.tokenize,
            P = void 0 !== j && j,
            I = r.matchAllTokens,
            F = void 0 !== I && I,
            T = r.includeMatches,
            N = void 0 !== T && T,
            z = r.includeScore,
            E = void 0 !== z && z,
            W = r.verbose,
            K = void 0 !== W && W;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.options = {
          location: o,
          distance: a,
          threshold: h,
          maxPatternLength: u,
          isCaseSensitive: v,
          tokenSeparator: d,
          findAllMatches: y,
          minMatchCharLength: k,
          id: S,
          keys: M,
          includeMatches: N,
          includeScore: E,
          shouldSort: w,
          getFn: A,
          sortFn: C,
          verbose: K,
          tokenize: P,
          matchAllTokens: F
        }, this.setCollection(t), this._processKeys(M);
      }

      var t, r, a;
      return t = e, (r = [{
        key: "setCollection",
        value: function value(e) {
          return this.list = e, e;
        }
      }, {
        key: "_processKeys",
        value: function value(e) {
          if (this._keyWeights = {}, this._keyNames = [], e.length && "string" == typeof e[0]) for (var t = 0, r = e.length; t < r; t += 1) {
            var n = e[t];
            this._keyWeights[n] = 1, this._keyNames.push(n);
          } else {
            for (var o = null, i = null, a = 0, s = 0, c = e.length; s < c; s += 1) {
              var h = e[s];
              if (!h.hasOwnProperty("name")) throw new Error('Missing "name" property in key object');
              var l = h.name;
              if (this._keyNames.push(l), !h.hasOwnProperty("weight")) throw new Error('Missing "weight" property in key object');
              var u = h.weight;
              if (u < 0 || u > 1) throw new Error('"weight" property in key must bein the range of [0, 1)');
              i = null == i ? u : Math.max(i, u), o = null == o ? u : Math.min(o, u), this._keyWeights[l] = u, a += u;
            }

            if (a > 1) throw new Error("Total of weights cannot exceed 1");
          }
        }
      }, {
        key: "search",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            limit: !1
          };

          this._log('---------\nSearch pattern: "'.concat(e, '"'));

          var r = this._prepareSearchers(e),
              n = r.tokenSearchers,
              o = r.fullSearcher,
              i = this._search(n, o);

          return this._computeScore(i), this.options.shouldSort && this._sort(i), t.limit && "number" == typeof t.limit && (i = i.slice(0, t.limit)), this._format(i);
        }
      }, {
        key: "_prepareSearchers",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              t = [];
          if (this.options.tokenize) for (var r = e.split(this.options.tokenSeparator), n = 0, o = r.length; n < o; n += 1) {
            t.push(new i(r[n], this.options));
          }
          return {
            tokenSearchers: t,
            fullSearcher: new i(e, this.options)
          };
        }
      }, {
        key: "_search",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              t = arguments.length > 1 ? arguments[1] : void 0,
              r = this.list,
              n = {},
              o = [];

          if ("string" == typeof r[0]) {
            for (var i = 0, a = r.length; i < a; i += 1) {
              this._analyze({
                key: "",
                value: r[i],
                record: i,
                index: i
              }, {
                resultMap: n,
                results: o,
                tokenSearchers: e,
                fullSearcher: t
              });
            }

            return o;
          }

          for (var s = 0, c = r.length; s < c; s += 1) {
            for (var h = r[s], l = 0, u = this._keyNames.length; l < u; l += 1) {
              var f = this._keyNames[l];

              this._analyze({
                key: f,
                value: this.options.getFn(h, f),
                record: h,
                index: s
              }, {
                resultMap: n,
                results: o,
                tokenSearchers: e,
                fullSearcher: t
              });
            }
          }

          return o;
        }
      }, {
        key: "_analyze",
        value: function value(e, t) {
          var r = this,
              n = e.key,
              o = e.arrayIndex,
              i = void 0 === o ? -1 : o,
              a = e.value,
              s = e.record,
              h = e.index,
              l = t.tokenSearchers,
              u = void 0 === l ? [] : l,
              f = t.fullSearcher,
              v = t.resultMap,
              p = void 0 === v ? {} : v,
              d = t.results,
              g = void 0 === d ? [] : d;
          !function e(t, o, i, a) {
            if (null != o) if ("string" == typeof o) {
              var s = !1,
                  h = -1,
                  l = 0;

              r._log("\nKey: ".concat("" === n ? "--" : n));

              var v = f.search(o);

              if (r._log('Full text: "'.concat(o, '", score: ').concat(v.score)), r.options.tokenize) {
                for (var d = o.split(r.options.tokenSeparator), y = d.length, m = [], k = 0, b = u.length; k < b; k += 1) {
                  var S = u[k];

                  r._log('\nPattern: "'.concat(S.pattern, '"'));

                  for (var x = !1, M = 0; M < y; M += 1) {
                    var _ = d[M],
                        w = S.search(_),
                        L = {};
                    w.isMatch ? (L[_] = w.score, s = !0, x = !0, m.push(w.score)) : (L[_] = 1, r.options.matchAllTokens || m.push(1)), r._log('Token: "'.concat(_, '", score: ').concat(L[_]));
                  }

                  x && (l += 1);
                }

                h = m[0];

                for (var A = m.length, O = 1; O < A; O += 1) {
                  h += m[O];
                }

                h /= A, r._log("Token score average:", h);
              }

              var C = v.score;
              h > -1 && (C = (C + h) / 2), r._log("Score average:", C);
              var j = !r.options.tokenize || !r.options.matchAllTokens || l >= u.length;

              if (r._log("\nCheck Matches: ".concat(j)), (s || v.isMatch) && j) {
                var P = {
                  key: n,
                  arrayIndex: t,
                  value: o,
                  score: C
                };
                r.options.includeMatches && (P.matchedIndices = v.matchedIndices);
                var I = p[a];
                I ? I.output.push(P) : (p[a] = {
                  item: i,
                  output: [P]
                }, g.push(p[a]));
              }
            } else if (c(o)) for (var F = 0, T = o.length; F < T; F += 1) {
              e(F, o[F], i, a);
            }
          }(i, a, s, h);
        }
      }, {
        key: "_computeScore",
        value: function value(e) {
          this._log("\n\nComputing score:\n");

          for (var t = this._keyWeights, r = !!Object.keys(t).length, n = 0, o = e.length; n < o; n += 1) {
            for (var i = e[n], a = i.output, s = a.length, c = 1, h = 0; h < s; h += 1) {
              var l = a[h],
                  u = l.key,
                  f = r ? t[u] : 1,
                  v = 0 === l.score && t && t[u] > 0 ? Number.EPSILON : l.score;
              c *= Math.pow(v, f);
            }

            i.score = c, this._log(i);
          }
        }
      }, {
        key: "_sort",
        value: function value(e) {
          this._log("\n\nSorting...."), e.sort(this.options.sortFn);
        }
      }, {
        key: "_format",
        value: function value(e) {
          var t = [];

          if (this.options.verbose) {
            var r = [];
            this._log("\n\nOutput:\n\n", JSON.stringify(e, function (e, t) {
              if ("object" === n(t) && null !== t) {
                if (-1 !== r.indexOf(t)) return;
                r.push(t);
              }

              return t;
            }, 2)), r = null;
          }

          var o = [];
          this.options.includeMatches && o.push(function (e, t) {
            var r = e.output;
            t.matches = [];

            for (var n = 0, o = r.length; n < o; n += 1) {
              var i = r[n];

              if (0 !== i.matchedIndices.length) {
                var a = {
                  indices: i.matchedIndices,
                  value: i.value
                };
                i.key && (a.key = i.key), i.hasOwnProperty("arrayIndex") && i.arrayIndex > -1 && (a.arrayIndex = i.arrayIndex), t.matches.push(a);
              }
            }
          }), this.options.includeScore && o.push(function (e, t) {
            t.score = e.score;
          });

          for (var i = 0, a = e.length; i < a; i += 1) {
            var s = e[i];

            if (this.options.id && (s.item = this.options.getFn(s.item, this.options.id)[0]), o.length) {
              for (var c = {
                item: s.item
              }, h = 0, l = o.length; h < l; h += 1) {
                o[h](s, c);
              }

              t.push(c);
            } else t.push(s.item);
          }

          return t;
        }
      }, {
        key: "_log",
        value: function value() {
          var e;
          this.options.verbose && (e = console).log.apply(e, arguments);
        }
      }]) && o(t.prototype, r), a && o(t, a), e;
    }();

    e.exports = h;
  }, function (e, t, r) {
    function n(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var o = r(2),
        i = r(3),
        a = r(6),
        s = function () {
      function e(t, r) {
        var n = r.location,
            o = void 0 === n ? 0 : n,
            i = r.distance,
            s = void 0 === i ? 100 : i,
            c = r.threshold,
            h = void 0 === c ? .6 : c,
            l = r.maxPatternLength,
            u = void 0 === l ? 32 : l,
            f = r.isCaseSensitive,
            v = void 0 !== f && f,
            p = r.tokenSeparator,
            d = void 0 === p ? / +/g : p,
            g = r.findAllMatches,
            y = void 0 !== g && g,
            m = r.minMatchCharLength,
            k = void 0 === m ? 1 : m,
            b = r.includeMatches,
            S = void 0 !== b && b;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.options = {
          location: o,
          distance: s,
          threshold: h,
          maxPatternLength: u,
          isCaseSensitive: v,
          tokenSeparator: d,
          findAllMatches: y,
          includeMatches: S,
          minMatchCharLength: k
        }, this.pattern = v ? t : t.toLowerCase(), this.pattern.length <= u && (this.patternAlphabet = a(this.pattern));
      }

      var t, r, s;
      return t = e, (r = [{
        key: "search",
        value: function value(e) {
          var t = this.options,
              r = t.isCaseSensitive,
              n = t.includeMatches;

          if (r || (e = e.toLowerCase()), this.pattern === e) {
            var a = {
              isMatch: !0,
              score: 0
            };
            return n && (a.matchedIndices = [[0, e.length - 1]]), a;
          }

          var s = this.options,
              c = s.maxPatternLength,
              h = s.tokenSeparator;
          if (this.pattern.length > c) return o(e, this.pattern, h);
          var l = this.options,
              u = l.location,
              f = l.distance,
              v = l.threshold,
              p = l.findAllMatches,
              d = l.minMatchCharLength;
          return i(e, this.pattern, this.patternAlphabet, {
            location: u,
            distance: f,
            threshold: v,
            findAllMatches: p,
            minMatchCharLength: d,
            includeMatches: n
          });
        }
      }]) && n(t.prototype, r), s && n(t, s), e;
    }();

    e.exports = s;
  }, function (e, t) {
    var r = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;

    e.exports = function (e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : / +/g,
          o = new RegExp(t.replace(r, "\\$&").replace(n, "|")),
          i = e.match(o),
          a = !!i,
          s = [];
      if (a) for (var c = 0, h = i.length; c < h; c += 1) {
        var l = i[c];
        s.push([e.indexOf(l), l.length - 1]);
      }
      return {
        score: a ? .5 : 1,
        isMatch: a,
        matchedIndices: s
      };
    };
  }, function (e, t, r) {
    var n = r(4),
        o = r(5);

    e.exports = function (e, t, r, i) {
      for (var a = i.location, s = void 0 === a ? 0 : a, c = i.distance, h = void 0 === c ? 100 : c, l = i.threshold, u = void 0 === l ? .6 : l, f = i.findAllMatches, v = void 0 !== f && f, p = i.minMatchCharLength, d = void 0 === p ? 1 : p, g = i.includeMatches, y = void 0 !== g && g, m = s, k = e.length, b = u, S = e.indexOf(t, m), x = t.length, M = [], _ = 0; _ < k; _ += 1) {
        M[_] = 0;
      }

      if (-1 !== S) {
        var w = n(t, {
          errors: 0,
          currentLocation: S,
          expectedLocation: m,
          distance: h
        });

        if (b = Math.min(w, b), -1 !== (S = e.lastIndexOf(t, m + x))) {
          var L = n(t, {
            errors: 0,
            currentLocation: S,
            expectedLocation: m,
            distance: h
          });
          b = Math.min(L, b);
        }
      }

      S = -1;

      for (var A = [], O = 1, C = x + k, j = 1 << (x <= 31 ? x - 1 : 30), P = 0; P < x; P += 1) {
        for (var I = 0, F = C; I < F;) {
          n(t, {
            errors: P,
            currentLocation: m + F,
            expectedLocation: m,
            distance: h
          }) <= b ? I = F : C = F, F = Math.floor((C - I) / 2 + I);
        }

        C = F;
        var T = Math.max(1, m - F + 1),
            N = v ? k : Math.min(m + F, k) + x,
            z = Array(N + 2);
        z[N + 1] = (1 << P) - 1;

        for (var E = N; E >= T; E -= 1) {
          var W = E - 1,
              K = r[e.charAt(W)];

          if (K && (M[W] = 1), z[E] = (z[E + 1] << 1 | 1) & K, 0 !== P && (z[E] |= (A[E + 1] | A[E]) << 1 | 1 | A[E + 1]), z[E] & j && (O = n(t, {
            errors: P,
            currentLocation: W,
            expectedLocation: m,
            distance: h
          })) <= b) {
            if (b = O, (S = W) <= m) break;
            T = Math.max(1, 2 * m - S);
          }
        }

        if (n(t, {
          errors: P + 1,
          currentLocation: m,
          expectedLocation: m,
          distance: h
        }) > b) break;
        A = z;
      }

      var $ = {
        isMatch: S >= 0,
        score: 0 === O ? .001 : O
      };
      return y && ($.matchedIndices = o(M, d)), $;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = t.errors,
          n = void 0 === r ? 0 : r,
          o = t.currentLocation,
          i = void 0 === o ? 0 : o,
          a = t.expectedLocation,
          s = void 0 === a ? 0 : a,
          c = t.distance,
          h = void 0 === c ? 100 : c,
          l = n / e.length,
          u = Math.abs(s - i);
      return h ? l + u / h : u ? 1 : l;
    };
  }, function (e, t) {
    e.exports = function () {
      for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, r = [], n = -1, o = -1, i = 0, a = e.length; i < a; i += 1) {
        var s = e[i];
        s && -1 === n ? n = i : s || -1 === n || ((o = i - 1) - n + 1 >= t && r.push([n, o]), n = -1);
      }

      return e[i - 1] && i - n >= t && r.push([n, i - 1]), r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      for (var t = {}, r = e.length, n = 0; n < r; n += 1) {
        t[e.charAt(n)] = 0;
      }

      for (var o = 0; o < r; o += 1) {
        t[e.charAt(o)] |= 1 << r - o - 1;
      }

      return t;
    };
  }, function (e, t) {
    var r = function r(e) {
      return Array.isArray ? Array.isArray(e) : "[object Array]" === Object.prototype.toString.call(e);
    },
        n = function n(e) {
      return null == e ? "" : function (e) {
        if ("string" == typeof e) return e;
        var t = e + "";
        return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
      }(e);
    },
        o = function o(e) {
      return "string" == typeof e;
    },
        i = function i(e) {
      return "number" == typeof e;
    };

    e.exports = {
      get: function get(e, t) {
        var a = [];
        return function e(t, s) {
          if (s) {
            var c = s.indexOf("."),
                h = s,
                l = null;
            -1 !== c && (h = s.slice(0, c), l = s.slice(c + 1));
            var u = t[h];
            if (null != u) if (l || !o(u) && !i(u)) {
              if (r(u)) for (var f = 0, v = u.length; f < v; f += 1) {
                e(u[f], l);
              } else l && e(u, l);
            } else a.push(n(u));
          } else a.push(t);
        }(e, t), a;
      },
      isArray: r,
      isString: o,
      isNum: i,
      toString: n
    };
  }]);
});